var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am-header-info"},[_c('div',{staticClass:"am-header-info-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"am-header-info-value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }